import {
  type WorkplaceProfileResponse,
  workplaceProfileResponseSchema,
  workplaceProfileUpdateSchema,
} from "@clipboard-health/contract-backend-main";
import { patch } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

interface UpdateLateCancellationCallNotificationParams {
  workplaceId: string;
  workerAttendanceNotifications: {
    enabled: boolean;
    instructions?: string;
  };
}

export function useUpdateLateCancellationCallNotification(
  options: UseMutationOptions<
    WorkplaceProfileResponse,
    unknown,
    UpdateLateCancellationCallNotificationParams
  > = {}
) {
  return useMutation({
    mutationFn: async ({ workplaceId, workerAttendanceNotifications }) => {
      const response = await patch({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/workplaces/${workplaceId}`,
        data: {
          data: {
            id: workplaceId,
            type: "workplace",
            attributes: { workerAttendanceNotifications },
          },
        },
        requestSchema: workplaceProfileUpdateSchema,
        responseSchema: workplaceProfileResponseSchema,
      });
      return response.data;
    },
    ...options,
  });
}
